define('SuiteDynamics.B2BPromoMessaging.HomeModifications',
	[
		'underscore'
	],
	function (
		_
	)
{
	'use strict';

	function processCarousel(carousel, fallbackImages) {
		var processedCarousel;
		if (!_.isEmpty(carousel)) {
			processedCarousel = _.map(carousel, function (item) {
				var clonedItem = _.extend({}, item);
				if (!_.isEmpty(clonedItem.image)) {
					clonedItem.isAbsoluteUrl = (clonedItem.image.indexOf('core/media') !== -1);
				}
				return clonedItem;
			});
		} else {
			processedCarousel = fallbackImages;
		}
		return processedCarousel;
	}

	return {
		mountToApp: function mountToApp (container) {
			var layout = container.getComponent('Layout');
			var userProfileComp = container.getComponent('UserProfile');
			var environment = container.getComponent('Environment');

			if (layout && userProfileComp) {
				userProfileComp.getUserProfile().then(function (profile) {
					var customFields = profile.customfields || [];
					var isB2BField = _.findWhere(customFields, { id: 'custentity_ano_is_b2b' });
					var isB2B = (isB2BField && (isB2BField.value === true || isB2BField.value === 'T'))
					var carouselImages = environment.getConfig('home.themeCarouselImagesB2B') || [];

					layout.addToViewContextDefinition('Home.View', 'isB2B', 'boolean', function () {
						return isB2B;
					});

					if (isB2B) {
						layout.addToViewContextDefinition('Home.View', 'isB2BCarouselReady', 'boolean', function (context) {
							return (_.has(context, 'isReady') && !_.isUndefined(context.isReady)) ? context.isReady : true;
						});

						layout.addToViewContextDefinition('Home.View', 'showB2BCarousel', 'boolean', function (context) {
							var processedCarousel = processCarousel(context.carousel, carouselImages);
							return (isB2B && processedCarousel && processedCarousel.length > 0);
						});

						layout.addToViewContextDefinition('Home.View', 'carouselB2B', 'array', function (context) {
							return processCarousel(context.carousel, carouselImages);
						});
					}
				});
			}
		}
	};
});
